import * as React from 'react'
import { useSelector } from 'react-redux'
import { usePermission } from 'admin/hocs'
import { getActiveAccountSlug, isUserReseller } from 'auth/selectors'
import { useHasFeatureFunc } from 'utils/useHasFeature'
import { DirectoryPage, PageResult, searchPages } from '../pageDirectory'
import { MIN_QUERY_LENGTH } from '../schema'

// Control Panel pages matching the query, gated by the same permission and
// feature checks the sidebar menu applies.
export const usePageResults = (query: string, enabled: boolean): PageResult[] => {
    const accountSlug = useSelector(getActiveAccountSlug)
    const isReseller = useSelector(isUserReseller)
    const { hasPermission } = usePermission()
    const hasFeature = useHasFeatureFunc()

    const trimmedQuery = query.trim()

    return React.useMemo(() => {
        if (!enabled || !accountSlug || trimmedQuery.length < MIN_QUERY_LENGTH) {
            return []
        }
        const canAccess = (page: DirectoryPage): boolean => {
            if (page.hideForReseller && isReseller) {
                return false
            }
            if (page.permissions && !page.permissions.some((permission) => hasPermission(permission, accountSlug))) {
                return false
            }
            if (page.feature && !hasFeature(page.feature)) {
                return false
            }
            if (page.featureOff && hasFeature(page.featureOff)) {
                return false
            }
            return true
        }
        return searchPages(trimmedQuery, accountSlug, canAccess)
    }, [enabled, accountSlug, trimmedQuery, isReseller, hasPermission, hasFeature])
}
